/**
 * The contacts we already hold for an employer, as the recruiter screens
 * count them.
 *
 * "N contacts" on the employment table, in the drawer block and under the
 * picker must all be the same N, so the rule lives here and nowhere else:
 * a contact counts when there is something to reach them by. A name alone
 * is not a contact method. The API's `carrierContactCount` applies the same
 * rule server-side.
 *
 * Order is the directory's order (`carrierByDotNumber.contacts`: preferred
 * first, then most-seen), left as it arrives. The first reachable contact is
 * the one "Use" and the carrier-pick prefill take.
 */

export interface KnownContact {
  contactId: string
  contactName?: string | null
  phoneNumber?: string | null
  email?: string | null
  source?: string | null
  occurrenceCount?: number | null
}

export const isReachableContact = (contact: {
  phoneNumber?: string | null
  email?: string | null
}): boolean => Boolean(contact.phoneNumber?.trim() || contact.email?.trim())

export const reachableContacts = <T extends KnownContact>(
  contacts: T[] | null | undefined
): T[] => (contacts ?? []).filter(isReachableContact)

/** "3 contacts", "1 contact", "0 contacts" — the one vocabulary. A number, never "No". */
export const formatContactCount = (count: number): string => {
  if (count <= 0) return '0 contacts'
  return count === 1 ? '1 contact' : `${count} contacts`
}
